export interface AuthPlugin {
  login(credentials: { username: string, password: string }): Promise<any>;
  getCredentials(): Promise<any>;
  logout(): Promise<void>;
  socialLogin(input: { connection: string }): Promise<any>;
  hasValidCredentials(): Promise<{ hasValidCredentials: boolean }>;
}
